import { Tabs } from '@ui/lib/park/ui/tabs';
import React from 'react';

type ExchangeRootProps = React.ComponentProps<typeof Tabs.Root> & {
  children: React.ReactNode;
};

export const ExchangeRoot = (props: ExchangeRootProps) => {
  const { children, defaultValue, ...tabsRootProps } = props;
  const options =
    React.Children.map(children, (child) => {
      if (!React.isValidElement(child)) {
        return { id: 'unknow', label: 'unknow', disabled: true };
      }

      return {
        id: child.props.label,
        label: child.props.label,
        disabled: child.props.disabled,
      };
    }) || [];

  return (
    <Tabs.Root
      variant="line"
      h="full"
      width="full"
      defaultValue={defaultValue ?? options[0]?.id}
      {...tabsRootProps}
    >
      <Tabs.List>
        {options.map((option) => (
          <Tabs.Trigger minW={0} key={option.id} value={option.id}>
            {option.label}
          </Tabs.Trigger>
        ))}
        {options.length > 1 && <Tabs.Indicator />}
      </Tabs.List>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) {
          return child;
        }

        return (
          <Tabs.Content h="full" px={1} value={child.props.label}>
            {child}
          </Tabs.Content>
        );
      })}
    </Tabs.Root>
  );
};
